import { request, type DataInfoResponse, type PagedList } from './request';
import { buildListParams } from './params';
import type { DocLabelDto, DoctorDto } from './types';

/** 医师标签类型（对齐后端 DoctorLabelType 枚举） */
export const DOCTOR_LABEL_TYPE = {
  /** 医师级别 */
  LEVEL: 1,
  /** 擅长方向 */
  SUBJECT: 2,
  /** 个人标签 */
  PERSONAL: 3,
  /** 医师身份 */
  IDENTITY: 4,
} as const;

export interface DoctorListOptions {
  pageIndex?: number;
  pageSize?: number;
  /** 姓名搜索 */
  name?: string;
  /** 医院单位搜索 */
  hospital?: string;
  /** 标签ID筛选列表 */
  labelIdList?: number[];
}

/** 医师列表（/doctor/userGetDoctorList，公开接口） */
export function fetchDoctorList(options: DoctorListOptions = {}): Promise<PagedList<DoctorDto>> {
  const { pageIndex = 1, pageSize = 10, name = '', hospital = '', labelIdList = [] } = options;

  return request(
    '/doctor/userGetDoctorList',
    buildListParams({
      pageIndex,
      pageSize,
      state: 1,
      name,
      extra: {
        mobile: '',
        identityType: '',
        userId: 0,
        phyCertNum: '',
        praCertNum: '',
        hospital,
        subject: '',
        labelIdList,
        checkState: 0,
      },
    }),
  );
}

/** 医师详情（/doctor/userGetDoctorInfo，公开接口） */
export function fetchDoctorInfo(id: number): Promise<DataInfoResponse<DoctorDto>> {
  return request('/doctor/userGetDoctorInfo', { id });
}

/** 医师标签列表（/doctor/userGetDocLabelList，公开接口） */
export function fetchDocLabelList(
  labelType: number = DOCTOR_LABEL_TYPE.SUBJECT,
  name = '',
): Promise<PagedList<DocLabelDto>> {
  return request(
    '/doctor/userGetDocLabelList',
    buildListParams({
      pageIndex: 1,
      pageSize: 999,
      state: 1,
      name,
      extra: { labelType },
    }),
  );
}
